import Layout from "../UI/Layout/Layout";
import Hero from "../UI/Hero/Hero";
import hero from "../../assets/image/lawyers/hero.webp";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import Intro from "./Intro/Intro";
import Team from "./Team/Team";
import Seo from "../UI/Seo/Seo";

const Lawyers = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <Layout authLevelRequired={false}>
      <Seo
        title="Rechtsanwältinnen und Rechtsanwälte"
        description="Lernen Sie das Team der Wilms Rechtsanwälte in Berlin-Tempelhof kennen – erfahrene Anwält:innen für ein breites Spektrum an Rechtsgebieten."
        path="/rechtsanwaelte"
      />
      <div>
        <Hero
          image={hero}
          small
          subtitle={t.lawyers.hero.subtitle}
          title={t.lawyers.hero.title}
        />
        <Intro />
        <Team />
      </div>
    </Layout>
  );
};

export default Lawyers;
